import { FormBaseTableComponent } from '../form-base-table/form-base-table.component';
import { Component } from '@angular/core';
import { biKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-form-bi-table',
    templateUrl: './form-bi-table.component.html',
    styleUrls: ['../form-base-table/form-base-table.scss'],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        Tooltip,
        TranslatePipe,
    ],
})
export class FormBiTableComponent extends FormBaseTableComponent {

    constructor() {
        super();
        this.generateColumns(biKeys);
    }
}
